import React, { useEffect, useState } from "react";
import {
  Grid,
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Typography,
  Avatar,
  Link,
} from "@mui/material";

import Header from "../Component/Header";
import Footer from "../Component/Footer";
import SubFooter from "../Component/SubFooter";
import axios from "axios";
import config from "../config";
import moment from "moment";

export default function Account() {
  const [dataUser, setDataUser] = useState({});
  const [downloadList, setDownloadList] = useState([]);
  const auth = JSON.parse(localStorage.getItem("access_token"));
  const axiosConfig = {
    headers: {
      Authorization: `Bearer ${auth.token}`,
    },
  };
  /* eslint-disable */
  useEffect(() => {
    axios.get(`${config.url}/me`, axiosConfig).then((res) => {
      setDataUser(res.data.data);
      getUserDownload();
    });
  }, []);

  const getUserDownload = async () => {
    const res = await axios.get(
      `${config.url}/product_user_downloads`,
      axiosConfig
    );

    if (res.status === 200 && res.data.data.length > 0) {
      setDownloadList(res.data.data);
    }
  };

  return (
    <>
      <Header />
      <Container maxWidth="xl" spacing={2} sx={{ pt: "30px", pb: "30px" }}>
        <Grid container>
          <Grid
            item
            xs={12}
            lg={4}
            sx={{
              border: "1px solid #ddd",
              borderRadius: "10px",
              p: "20px",
            }}
          >
            <Avatar
              alt="Remy Sharp"
              sx={{ width: 150, height: 150, m: "0 auto", mb: "30px" }}
            >
              AN
            </Avatar>
            <Typography
              variant="h5"
              sx={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
                mb: "20px",
              }}
            >
              {dataUser.username}
            </Typography>
            <Typography sx={{ mb: "10px" }}>
              <strong>Username</strong>
            </Typography>
            <Typography sx={{ mb: "10px" }}>{dataUser.username}</Typography>
            <Typography sx={{ mb: "10px" }}>
              <strong>Email</strong>
            </Typography>
            <Typography sx={{ mb: "10px" }}>{dataUser.email}</Typography>
            <Typography sx={{ mb: "10px" }}>
              <strong>Member Since</strong>
            </Typography>
            <Typography sx={{ mb: "10px" }}>
              {moment(dataUser.createdAt).format("DD MMMM YYYY")}
            </Typography>
            <Typography sx={{ mb: "10px" }}>
              <strong>Account Status</strong>
            </Typography>
            <Typography sx={{ mb: "10px" }}>Account</Typography>
            <Link href="/edit-profile" underline="none">
              <Button
                variant="contained"
                fullWidth
                sx={{ background: "#cc0600" }}
              >
                Edit Profile
              </Button>
            </Link>
          </Grid>

          <Grid
            item
            xs={12}
            lg={8}
            sx={{
              border: "1px solid #ddd",
              borderRadius: "10px",
              p: "20px",
            }}
          >
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>Logo</TableCell>
                    <TableCell align="left">Product Name</TableCell>
                    <TableCell align="left">Publisher</TableCell>
                    <TableCell align="left">Categories</TableCell>
                    <TableCell align="left">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {downloadList?.map((data, idx) => (
                    <TableRow
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                      key={idx}
                    >
                      <TableCell align="left">
                        {/* <Stack direction='row' spacing={2}> */}
                        <img
                          src={data?.product?.logo_full_path}
                          alt="logo"
                          style={{ width: "20%", borderRadius: "20px" }}
                        />
                        {/* <Typography variant='body2' sx={{ mt: '50%' }}>
                            {data?.product?.name}
                          </Typography>
                        </Stack> */}
                      </TableCell>
                      <TableCell align="left">{data?.product?.name}</TableCell>
                      <TableCell align="left">
                        PT MCash Integrasi, Tbk
                      </TableCell>
                      <TableCell align="left">
                        {data?.product?.product_category?.name}
                      </TableCell>
                      <TableCell align="left">
                        <Link
                          href={`${data?.product?.link_download}`}
                          underline="none"
                        >
                          <Button
                            variant="contained"
                            style={{
                              borderRadius: "30px",
                              background: "#228B22",
                            }}
                          >
                            download
                          </Button>
                        </Link>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Container>
      <Footer />
      <SubFooter />
    </>
  );
}
